import React, { Component } from 'react';
import './Demographics.css';
import 'bootstrap/dist/css/bootstrap.css';
import DemographicsGraph from '../../components/GraphResults/DemographicsGraph.js';

class CompareDemographicsTable extends Component {

  render() {

      return (
          <table className="px-5 align-top">
            <thead>
              <tr className="companySection companyNames">
                <th><div className="companyChartLegend companyFixed"></div></th>
                {this.props.companies.map(company => (
                  <th colSpan="3" className="companyGridLeft">
                    <h2 className="companyCol">{company.data['Primary Business Name']}</h2>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="companySection companyDetails">
                <td className="companyFixed"></td>
                {this.props.companies.map(company => (
                  <td colSpan="3" className="text-left companyCol companyGridLeft p-3" >
                    {company.data['Main Office Street Address 1']}<br />
                    {company.data['Main Office Street Address 2'] !== null ? <>{company.data['Main Office Street Address 2']}<br /></> : ''}
                    {company.data['Main Office City']}, {company.data['Main Office State']} {company.data['Main Office Postal Code']}<br />
                    {company.data['Main Office Telephone Number']}<br />
                    {company.data['Website Address'] != null ? <><a href={company.data['Website Address']} target="_blank" rel="noopener noreferrer">{company.data['Website Address']}</a><br /></> : ''}
                    {company.data['Organization CRD#'] != null ? <>Organization CRD#: {company.data['Organization CRD#']}<br /></> : ''}
                    {company.data['SEC#'] != null ? <>SEC#: {company.data['SEC#']}<br /></> : ''}
                  </td>
                ))}
              </tr>
              <tr className="companySection companyCharts companyHeaderRow">
                <td className="p-3 companyFixed text-left font-weight-bold">AUM</td>
                {this.props.companies.map(company => (<>
                  <td className="companyGridLeft p-3 text-right font-weight-bold">Value</td>
                  <td className=" p-3 text-right font-weight-bold">Accounts</td>
                  <td className=" p-3 text-right font-weight-bold">Avg. Size/Acct.</td>
                </>
                ))}
              </tr>
              {
                this.props.clientListFilteredAll.map(c => (
                  <tr key={c.type}>
                    <td className="text-left p-3 companyFixed">{c.type}</td>
                    {this.props.companies.map(company => (
                      (company.clientListFiltered.findIndex(item => item.type === c.type) > -1) ?
                        <>
                          <td className="text-right companyGridLeft p-3">${new Intl.NumberFormat().format(company.data[c.aum])}</td>
                          <td className="text-right  p-3">{company.data[c.account] !== null ? company.data[c.account] : 0}</td>
                          <td className="text-right  p-3">${company.data[c.account] > 0 ? (new Intl.NumberFormat().format(Math.round(company.data[c.aum] / (!isNaN(company.data[c.account]) ? company.data[c.account] : 5)))) : 0}</td>
                        </> :
                        <>
                          <td className="companyGridLeft"></td>
                          <td className=""></td>
                          <td className=""></td>
                        </>

                    ))}
                  </tr>
                ))
              }
              {
                <tr>
                  <td className="text-left other companyFixed p-3">Other (Not Listed Above)</td>
                  {this.props.companies.map(company => (
                    (company.clientAUMTotal < company.data['5F(2)(c) AUM Total'] || company.clientAccountTotal < company.data['5F(2)(f) Total # accts.']) ?
                      <>
                        <td className="text-right other companyGridLeft p-3">${new Intl.NumberFormat().format(company.data['5F(2)(c) AUM Total'] - company.clientAUMTotal)}</td>
                        <td className="text-right other  p-3">{(company.data['5F(2)(f) Total # accts.'] - company.clientAccountTotal)}</td>
                        <td className="text-right other  p-3"></td>
                      </> :
                      <>
                        <td className="companyGridLeft"></td>
                        <td className=""></td>
                        <td className=""></td>
                      </>

                  ))}
                </tr>
              }
              {
                this.props.totalListFilteredAll.map(c => (
                  <tr key={c.type}>
                    <td className="text-left total p-3 companyFixed">{c.type}</td>
                    {this.props.companies.map(company => (
                      (company.totalListFiltered.findIndex(item => item.type === c.type) > -1) ?
                        <>
                          <td className="text-right total companyGridLeft p-3">${new Intl.NumberFormat().format(company.data[c.aum])}</td>
                          <td className="text-right total  p-3">{company.data[c.account] !== null ? company.data[c.account] : 0}</td>
                          <td className="text-right total  p-3">${company.data[c.account] > 0 ? (new Intl.NumberFormat().format(Math.round(company.data[c.aum] / (!isNaN(company.data[c.account]) ? company.data[c.account] : 5)))) : 0}</td>
                        </> :
                        <>
                          <td className="companyGridLeft"></td>
                          <td className=""></td>
                          <td className=""></td>
                        </>

                    ))}
                  </tr>
                ))
              }
              <tr className="companySection companyGraphs">
                <td className="companyFixed">&nbsp;</td>
                {this.props.companies.map(company => (
                  <td colSpan="3" className="companyGridLeft p-3">
                    <DemographicsGraph clientToken={this.props.clientToken} secID={company.secID} orgID={this.props.orgID} />
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
      );

  }
}

export default CompareDemographicsTable;